import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ErrorBoundary } from '@/components/chrome/ErrorBoundary';
import { AppRouter } from '@/router/AppRouter';
import { queryClient } from '@/lib/queryClient';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={150} skipDelayDuration={300}>
          <AppRouter />
          <Toaster
            theme="light"
            position="bottom-right"
            toastOptions={{
              className:
                '!bg-bg-1 !border-line-1 !text-text-1 !rounded-xl font-sans shadow-card',
            }}
          />
          <ReactQueryDevtools initialIsOpen={false} />
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
